import { render, staticRenderFns } from "./Progetto.vue?vue&type=template&id=68b3e12b&scoped=true"
import script from "./Progetto.vue?vue&type=script&lang=js"
export * from "./Progetto.vue?vue&type=script&lang=js"
import style0 from "./Progetto.vue?vue&type=style&index=0&id=68b3e12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b3e12b",
  null
  
)

export default component.exports